import {
  createLifeCheckPromptStamp,
  hasRecentLifeCheckPromptDismissal,
} from '../../ui-foundation/features/notifications';

const LIFE_CHECK_PROMPT_PREFIX = 'adulting_life_check_prompt_dismissed';
const LIFE_CHECK_RESURFACE_PROMPT_PREFIX = 'adulting_life_check_resurface_prompt_dismissed';

function buildLifeCheckPromptKey(userId: string) {
  return `${LIFE_CHECK_PROMPT_PREFIX}:${userId}`;
}

function buildLifeCheckResurfacePromptKey(userId: string) {
  return `${LIFE_CHECK_RESURFACE_PROMPT_PREFIX}:${userId}`;
}

export function hasDismissedLifeCheckPrompt(userId: string | null | undefined) {
  if (!userId || typeof window === 'undefined') {
    return false;
  }

  return window.localStorage.getItem(buildLifeCheckPromptKey(userId)) === '1';
}

export function dismissLifeCheckPrompt(userId: string | null | undefined) {
  if (!userId || typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(buildLifeCheckPromptKey(userId), '1');
}

export function clearLifeCheckPrompt(userId: string | null | undefined) {
  if (!userId || typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(buildLifeCheckPromptKey(userId));
}

export function hasDismissedLifeCheckResurfacePrompt(userId: string | null | undefined) {
  if (!userId || typeof window === 'undefined') {
    return false;
  }

  return hasRecentLifeCheckPromptDismissal(
    window.localStorage.getItem(buildLifeCheckResurfacePromptKey(userId)),
  );
}

export function dismissLifeCheckResurfacePrompt(userId: string | null | undefined) {
  if (!userId || typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(
    buildLifeCheckResurfacePromptKey(userId),
    createLifeCheckPromptStamp(),
  );
}

export function clearLifeCheckResurfacePrompt(userId: string | null | undefined) {
  if (!userId || typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(buildLifeCheckResurfacePromptKey(userId));
}
